import { ReactNode } from 'react';

interface LockedPromptProps {
  icon?: string;
  image?: string;
  title: string;
  subtitle?: string;
  buttonText: string;
  onButtonClick: () => void;
  children?: ReactNode;
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
}

export default function LockedPrompt({
  icon,
  image,
  title,
  subtitle,
  buttonText,
  onButtonClick,
  children,
  secondaryAction,
}: LockedPromptProps) {
  return (
    <div className="flex flex-col items-center px-5 pt-4 pb-8">
      {/* Icon or Image */}
      {image ? (
        <div className="w-28 h-28 flex items-center justify-center mb-2">
          <img src={image} alt={title} className="w-full h-full object-contain" />
        </div>
      ) : (
        <div
          className="w-20 h-20 flex items-center justify-center rounded-3xl mb-5"
          style={{ background: 'linear-gradient(135deg, #818cf8, #6366f1)' }}
        >
          <i className={`${icon} text-white text-3xl`} />
        </div>
      )}

      {/* Title */}
      <h3 className="text-gray-900 font-bold text-lg text-center">{title}</h3>

      {/* Subtitle - optional, kept concise */}
      {subtitle && (
        <p className="text-gray-400 text-xs text-center mt-1.5 max-w-[260px]">
          {subtitle}
        </p>
      )}

      {/* Extra content (cards, preview, etc.) */}
      {children && <div className="w-full mt-5">{children}</div>}

      {/* Primary button */}
      <button
        onClick={onButtonClick}
        className="w-full mt-5 py-3.5 rounded-2xl text-white font-semibold text-sm flex items-center justify-center gap-2 active:opacity-80 transition-opacity"
        style={{ background: 'linear-gradient(135deg, #6366f1, #7c3aed)' }}
      >
        <i className="ri-login-box-line text-lg" />
        {buttonText}
      </button>

      {/* Secondary action */}
      {secondaryAction && (
        <button
          onClick={secondaryAction.onClick}
          className="mt-3 text-gray-400 text-xs font-medium py-2 active:text-gray-500 transition-colors"
        >
          {secondaryAction.label}
        </button>
      )}
    </div>
  );
}